import type { PropsWithChildren, Ref } from "react";
import { forwardRef } from "react";
import clsx from "clsx";

import { Typography } from "../typography";

import classes from "./styles.module.scss";
import type { IItemProps } from "./types";

export const MenuItem = forwardRef(function MenuItem(
  props: PropsWithChildren<IItemProps>,
  ref: Ref<HTMLDivElement>,
) {
  const { children, className, active, selected, ...rest } = props;

  return (
    <div
      ref={ref}
      className={clsx([
        classes.item,
        active && classes.active,
        selected && classes.selected,
        className,
      ])}
      {...rest}
    >
      <Typography
        color={"primary-text"}
        fontSize={"sm"}
        // fontWeight="semi-bold"
        className={"w-100"}
      >
        {children}
      </Typography>
    </div>
  );
});
